// utils
import handleError from 'utils/handle-error';
import clearReduxStore from 'utils/clear-redux-store';
import { callAzureFuncPublic } from './call-azure-function-auth';
import { store, persistor } from '../store';
import { setLoggedOut } from 'store/features/userSlice';

const handleLogout = async () => {
  try {
    // invalidate cookies
    await callAzureFuncPublic({
      url: `/logout`,
      method: 'post'
    });
  } catch (error) {
    handleError(error);
  } finally {
    // explicitly set logged out state before reset
    store.dispatch(setLoggedOut());

    // clear redux store values
    clearReduxStore();

    // purge persisted redux state from localStorage
    await persistor.purge();

    // clear all session storage
    sessionStorage.clear();

    // signal logout to other tabs
    localStorage.setItem('isLoggedIn', 'false');
  }
};

// eslint-disable-next-line import/prefer-default-export
export { handleLogout };
